<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <div class="vendor-form">
        <p class="vendor-form-label">
          Bentuk Badan Usaha<span class="text-ast">*</span>
        </p>
        <select
          v-model="$store.state.landingpage.badan_usaha_id"
          class="vendor-input"
        >
          <option
            v-for="(option, index) in bentukBadanUsaha"
            :key="index"
            :value="option.desc"
          >
            {{ option.desc }}
          </option>
        </select>
      </div>
      <div class="vendor-form">
        <p class="vendor-form-label">
          Nama Vendor<span class="text-ast">*</span>
        </p>
        <input
          type="text"
          class="vendor-input"
          v-model="vendorName"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>
      <div class="vendor-form">
        <p class="vendor-form-label">
          Kegiatan Usaha di Sistem OSS<span class="text-ast">*</span>
        </p>
        <div class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column10">Kode</p>
              <p class="column40 mr10">Judul</p>
              <p class="column10">NIB</p>
              <p class="column10">SS IZIN</p>
              <p class="column20">Dokumen Lainnya</p>
            </div>
            <div
              class="list-usaha-content"
              v-for="(list, index) in addedKbli"
              :key="index"
            >
              <p class="column10">{{ list.kode }}</p>
              <p class="column40 col-nohover mr10">{{ list.desc }}</p>
              <p class="column10">
                <input
                  type="checkbox"
                  :value="list.nib && list.nib"
                  v-model="addedKbli[index]['nib']"
                />
                {{ list.nib ? 'Ya' : 'Tidak' }}
              </p>
              <p class="column10">
                <input
                  type="checkbox"
                  :value="list.ss_izin && list.ss_izin"
                  v-model="addedKbli[index]['ss_izin']"
                />
                {{ list.ss_izin ? 'Ya' : 'Tidak' }}
              </p>
              <p class="column20">
                <input
                  type="checkbox"
                  :value="list.dokumen_lainnya && list.dokumen_lainnya"
                  v-model="addedKbli[index]['dokumen_lainnya']"
                />
                {{ list.dokumen_lainnya ? 'Ya' : 'Tidak' }}
              </p>
            </div>
          </div>
          <div @click="openModalKbli()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <a class="text-btn-landing">Tambah</a>
          </div>
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goAlamat()" class="btn-landing">Selanjutnya</div>
    </div>

    <Kbli v-if="$store.state.landingpage.addKbli" />
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'profil',
  components: {
    Kbli: () => import('@/components/modalLandingPage/AddKbli.vue'),
  },
  data() {
    return {
      bentukBadanUsaha: [],
      choosedBentukBadanUsaha: '',
    }
  },
  computed: {
    vendorName: {
      get: function() {
        return this.$store.state.landingpage.vendorName
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'vendorName',
          value: newValue,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'pemilikBank',
          value: newValue,
        })
      },
    },
    addedKbli: function() {
      return this.$store.state.landingpage.addedKbli
    },
  },
  created() {
    this.getBentukBadanUsaha()
  },
  methods: {
    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'instruction')
    },
    goAlamat() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
    },
    openModalKbli() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addKbli',
        status: true,
      })
    },
    async getBentukBadanUsaha() {
      const {
        bidang_usaha_id,
        type_pendaftaran_id,
      } = this.$store.state.landingpage
      const url = `${api}/api/v1/badan-usaha?page=1&limit=100&bidang_usaha_id=${bidang_usaha_id}&type_pendaftaran_id=${type_pendaftaran_id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.bentukBadanUsaha = data && data.data
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
  },
}
</script>
